//@ts-ignore
import BaseModel from './BaseModel';
// @ts-ignore
import crApi from '../service/CrApi';
// @ts-ignore
import SecurityService from "../service/SecurityService";

class MessageModel extends BaseModel {
    public async get(params = {}) {
        params['website_token'] = SecurityService.getToken();
        const result = await crApi.requestV2('message/retrieve/', params)
        result.message = await crApi.extractCollection(result.message);
        return result;
    };

    public async update(params = {}) {
        return  await crApi.requestV2('message', 'update', params);
    };

    public async getById(id, messageParams = {}) {
        const params = {};
        let code = + id;
        if (isNaN(code)) {
            params['textId'] = id;
        } else{
            params['messageId'] = id;
        }
        const alterParams = {};
        alterParams[id] = [];
        if (Array.isArray(messageParams)) {
            for (let i in messageParams) {
                alterParams[id].push(messageParams[i]);
            }
        }

        params['website_token'] = SecurityService.getToken();
        params['alterParams'] = alterParams;
        const result = await this.get(params);
        if(result.count === 0){
            return '';
        }
        return result['message'][0];
    };
}

export default new MessageModel();